"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterColors = void 0;
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var ColorUtils_1 = require("Common/Utils/ColorUtils/ColorUtils");
var blockConfigUtil_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/blockConfigUtil");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var BlockStyleTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/BlockStyleTypes");
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var ColorUtils_2 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
function wrapper(WrappedComponent, options) {
    var WithColorFilterComponent = (function (_super) {
        __extends(WithColorFilterComponent, _super);
        function WithColorFilterComponent(props) {
            var _this = _super.call(this, props) || this;
            _this.elementKeys = [
                commonTypes_1.TextElementType.H1,
                commonTypes_1.TextElementType.H2,
                commonTypes_1.TextElementType.P,
                commonTypes_1.TextElementType.Blockquote,
            ];
            _this.handleChange = function (color) {
                _this.color = color;
                var blockStyleStore = _this.props.blockStore.blockStyleStore;
                var newColor = _this.recommendedColors[_this.recommendedColors.length - 1];
                _this.elementKeys.forEach(function (type) {
                    var elementStyle = blockStyleStore.getElementStyle(type);
                    if (!elementStyle) {
                        return;
                    }
                    var elementProps = (0, lodash_1.cloneDeep)(elementStyle);
                    if (!_this.isColorValid(elementProps.color, _this.recommendedColors)) {
                        elementProps.color = {
                            abs: newColor.value,
                            themeIndex: newColor.themeIndex,
                        };
                        blockStyleStore.setElementStyle(type, elementProps);
                    }
                });
                if (blockStyleStore.model.headerSection) {
                    if (blockStyleStore.model.headerSection.color &&
                        !_this.isColorValid(blockStyleStore.model.headerSection.color, _this.recommendedColors)) {
                        var headerSectionStyle = __assign({}, blockStyleStore.model.headerSection);
                        headerSectionStyle.color = {
                            abs: newColor.value,
                            themeIndex: newColor.themeIndex,
                        };
                        blockStyleStore.setStylePropsByKey("headerSection", headerSectionStyle);
                    }
                    if (blockStyleStore.model.quoteBackgroundOn &&
                        blockStyleStore.model.uiHighlightColor.themeIndex === DefaultColors_1.DEFAULT_WHITE.themeIndex) {
                        blockStyleStore.setStylePropsByKey("uiHighlightColor", {
                            abs: _this.recommendedColors[0].value,
                            themeIndex: _this.recommendedColors[0].themeIndex,
                        });
                    }
                    else if (!blockStyleStore.model.quoteBackgroundOn &&
                        blockStyleStore.model.uiHighlightColor.themeIndex === color.themeIndex) {
                        blockStyleStore.setStylePropsByKey("uiHighlightColor", {
                            abs: _this.recommendedColors[0].value,
                            themeIndex: _this.recommendedColors[0].themeIndex,
                        });
                    }
                }
                if (blockStyleStore.model.acceptButton &&
                    blockStyleStore.model.acceptButton.color &&
                    !_this.isColorValid(blockStyleStore.model.acceptButton.color, _this.recommendedColors)) {
                    var newAcceptButtonStyle = __assign({}, blockStyleStore.model.acceptButton);
                    newAcceptButtonStyle.color = {
                        abs: newColor.value,
                        themeIndex: newColor.themeIndex,
                    };
                    blockStyleStore.setStylePropsByKey("acceptButton", newAcceptButtonStyle);
                }
                if (blockStyleStore.model.blockQuote &&
                    blockStyleStore.model.blockQuote.barColor &&
                    !_this.isColorValid(blockStyleStore.model.blockQuote.barColor, _this.recommendedColors)) {
                    blockStyleStore.model.blockQuote.barColor = {
                        abs: newColor.value,
                        themeIndex: newColor.themeIndex,
                    };
                }
                if (blockStyleStore.model.list &&
                    blockStyleStore.model.list.color &&
                    !_this.isColorValid(blockStyleStore.model.list.color, _this.recommendedColors)) {
                    blockStyleStore.model.list.color = {
                        abs: newColor.value,
                        themeIndex: newColor.themeIndex,
                    };
                }
                if (blockStyleStore.model.list &&
                    blockStyleStore.model.list.markerColor &&
                    !_this.isColorValid(blockStyleStore.model.list.markerColor, _this.recommendedColors)) {
                    blockStyleStore.model.list.markerColor = {
                        abs: newColor.value,
                        themeIndex: newColor.themeIndex,
                    };
                }
                if (blockStyleStore.model.link &&
                    blockStyleStore.model.link.color &&
                    !_this.isColorValid(blockStyleStore.model.link.color, _this.recommendedColors)) {
                    blockStyleStore.model.link.color = {
                        abs: newColor.value,
                        themeIndex: newColor.themeIndex,
                    };
                }
                if (blockStyleStore.model.link &&
                    blockStyleStore.model.link.underline &&
                    blockStyleStore.model.link.underline.color &&
                    !_this.isColorValid(blockStyleStore.model.link.underline.color, _this.recommendedColors)) {
                    blockStyleStore.model.link.underline.color = {
                        abs: newColor.value,
                        themeIndex: newColor.themeIndex,
                    };
                }
                (0, blockConfigUtil_1.addHash)(blockStyleStore.model);
            };
            var blockStyleStore = props.blockStore.blockStyleStore;
            _this.color = _this.getInitialBackground(blockStyleStore.model);
            return _this;
        }
        Object.defineProperty(WithColorFilterComponent.prototype, "filteredColors", {
            get: function () {
                var _a = this.props, colorsWithThemeIndex = _a.brandStore.colorsWithThemeIndex, blockStore = _a.blockStore;
                return (0, exports.filterColors)(colorsWithThemeIndex, this.color, blockStore.blockType, false);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(WithColorFilterComponent.prototype, "recommendedColors", {
            get: function () {
                var _a = this.props, colorsWithThemeIndex = _a.brandStore.colorsWithThemeIndex, blockStore = _a.blockStore;
                return (0, exports.filterColors)(colorsWithThemeIndex, this.color, blockStore.blockType, true);
            },
            enumerable: false,
            configurable: true
        });
        WithColorFilterComponent.prototype.render = function () {
            var filteredColors = this.filteredColors;
            if (options && options.includeGoldilocksColors) {
                var rgbaGoldilocksColors = DefaultColors_1.GOLDILOCKS_COLORS.map(function (color) {
                    if (color.value.startsWith("#")) {
                        color.value = (0, ColorUtils_2.getRgba)(color.value);
                    }
                    return color;
                });
                filteredColors = (0, uniqBy_1.default)(filteredColors.concat.apply(filteredColors, __spreadArray([], __read(rgbaGoldilocksColors), false)), "value");
            }
            return (react_1.default.createElement(WrappedComponent, __assign({ handleBackgroundChange: this.handleChange, filteredColors: filteredColors, colors: this.props.brandStore.colorsWithThemeIndex }, this.props)));
        };
        WithColorFilterComponent.prototype.getInitialBackground = function (blockStyle) {
            if ((0, BlockStyleTypes_1.isSplashStyle)(blockStyle)) {
                return blockStyle.backgroundCard.color;
            }
            else {
                return blockStyle.background;
            }
        };
        WithColorFilterComponent.prototype.isColorValid = function (color, filteredColors) {
            return filteredColors
                .map(function (_color) {
                return _color.themeIndex;
            })
                .includes(color.themeIndex);
        };
        var _a, _b;
        __decorate([
            mobx_1.observable,
            __metadata("design:type", Object)
        ], WithColorFilterComponent.prototype, "color", void 0);
        __decorate([
            mobx_1.computed,
            __metadata("design:type", Array),
            __metadata("design:paramtypes", [])
        ], WithColorFilterComponent.prototype, "filteredColors", null);
        __decorate([
            mobx_1.computed,
            __metadata("design:type", Array),
            __metadata("design:paramtypes", [])
        ], WithColorFilterComponent.prototype, "recommendedColors", null);
        __decorate([
            mobx_1.action,
            __metadata("design:type", Object)
        ], WithColorFilterComponent.prototype, "handleChange", void 0);
        WithColorFilterComponent = __decorate([
            mobx_react_1.observer,
            __metadata("design:paramtypes", [Object])
        ], WithColorFilterComponent);
        return WithColorFilterComponent;
    }(react_1.default.Component));
    return WithColorFilterComponent;
}
exports.default = wrapper;
var filterColors = function (colors, baseColor, blockType, isStronglyFiltered) {
    var filteredColors = getFirstFilteringOfColors(colors, baseColor, isStronglyFiltered);
    if (blockType !== commonTypes_1.BlockType.Splash) {
        return filterGrey(filteredColors);
    }
    else {
        return filterWhite(filterGrey(filteredColors)).concat([DefaultColors_1.DEFAULT_WHITE]);
    }
};
exports.filterColors = filterColors;
var getFirstFilteringOfColors = function (colors, baseColor, isStronglyFiltered) {
    if (isStronglyFiltered && isIColor(baseColor)) {
        return (0, ColorUtils_1.filterContrastingColors)(colors, baseColor.value);
    }
    else if (isStronglyFiltered) {
        return colors;
    }
    else {
        return colors.filter(function (color) {
            return color.themeIndex !== baseColor.themeIndex;
        });
    }
};
var filterGrey = function (colors) {
    return colors.filter(function (color) {
        return color.themeIndex !== DefaultColors_1.DEFAULT_GREY10.themeIndex;
    });
};
var filterWhite = function (colors) {
    return colors.filter(function (color) {
        return color.themeIndex !== DefaultColors_1.DEFAULT_WHITE.themeIndex;
    });
};
var isIColor = function (color) {
    return color.value != undefined;
};
